import React from "react"
import styled from "styled-components"
import {omit} from "lodash"
import id from "@irati/utils/id"

import IconText from "../../IconText"
import FocusOnKeyboard, {FocusOnKeyboardProps} from "../helpers/FocusOnKeyboard"

interface Props extends FocusOnKeyboardProps {}

const IconButton = (props: Props) => {
  const iconProps = omit(props, ["id", "onClick", "className"])
  const idNamespace = id("icon-button", props)

  return (
    <FocusOnKeyboard {...props} id={idNamespace}>
      <IconText id={id("icon", idNamespace)} {...iconProps} />
    </FocusOnKeyboard>
  )
}

IconButton.defaultProps = {
  className: null,
  inline: false
}

export default styled(IconButton)``
